import getConfig from 'next/config';
import { HTTPClient } from '../api';

const {
  BASE_URL_MEDIA,
  SENDGRID_ID_MARKETING_AUTO,
  SENDGRID_ID_MARKETING_HEALTH,
  SENDGRID_ID_MARKETING_LIFE,
} = getConfig().publicRuntimeConfig;

export const sendToSendgrid = async (data) => {
  const sendGridPayload = [{ email: data.email, source: 'leadform' }];
  const sendGridRequest = {
    method: 'POST',
    body: JSON.stringify(sendGridPayload),
  };

  return HTTPClient(`${BASE_URL_MEDIA}api/external/sendgrid/`, sendGridRequest);
};

export const sendToSendgridAuto = async (leadID, data) => {
  const sendGridPayload = {
    list_ids: SENDGRID_ID_MARKETING_AUTO,
    leadID: leadID,
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    phoneNumber: data.phoneNumber,
    carBrand: data.brand,
    carModel: data.model,
    carType: data.type,
    carYear: data.year,
    carArea: data.area,
  };

  const sendGridRequest = {
    method: 'POST',
    body: JSON.stringify(sendGridPayload),
  };

  return HTTPClient(`${BASE_URL_MEDIA}api/external/sendgrid-marketing/`, sendGridRequest);
};

export const sendToSendgridHealth = async (leadID, data) => {
  const sendGridPayload = {
    list_ids: SENDGRID_ID_MARKETING_HEALTH,
    leadID: leadID,
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    phoneNumber: data.phoneNumber,
    gender: data.gender,
    age: data.age,
  };

  const sendGridRequest = {
    method: 'POST',
    body: JSON.stringify(sendGridPayload),
  };

  return HTTPClient(`${BASE_URL_MEDIA}api/external/sendgrid-marketing/`, sendGridRequest);
};

export const sendToSendgridLife = async (leadID, data) => {
  const sendGridPayload = {
    list_ids: SENDGRID_ID_MARKETING_LIFE,
    leadID: leadID,
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    phoneNumber: data.phoneNumber,
    gender: data.gender,
    age: data.age,
  }
  ;
  const sendGridRequest = {
    method: 'POST',
    body: JSON.stringify(sendGridPayload),
  };

  return HTTPClient(`${BASE_URL_MEDIA}api/external/sendgrid-marketing/`, sendGridRequest);
};
